import { TowerModelDto } from '@groundfloor-platform/mgmt-service-g-sdk';

/**
 * Checks whether any of the given tower model names are double-sided.
 */
export class TowerModelUtils {
  constructor() {}

  static hasDoubleSidedTower(towerModelNames: string[], towerModels: TowerModelDto[]): boolean {
    return towerModelNames.some((name) => {
      const model = towerModels.find((m) => m.name === name);
      return model?.isDoubleSided ?? false;
    });
  }
}
